module.exports = {"downloadStatement":"Baixar extrato","downloadStatementCSV":"Baixar extrato CSV","printStatement":"Imprimir extrato","shareStatement":"Enviar extrato por e-mail","modal":{"title":"Já vamos enviar o seu extrato.","description":"Diga pra gente o e-mail em que você quer receber seu extrato.","buttonText":"Enviar","label":"E-mail","placeholder":"Ex nome@exemplo.com.br"}}


//////////////////
// WEBPACK FOOTER
// ./src/app/elements/StatementsHeader/data.json
// module id = 1933
// module chunks = 0